<!--
 * @Author: zl
 * @Date: 2022-09-15 13:48:33
 * @LastEditTime: 2022-09-16 14:54:42
 * @LastEditors: zl
 * @Description: 审计奖罚单
-->
<template>
	<div class='AuditPenalty-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center">奖 罚 单</h2>
				<el-descriptions :column="1"
								 size="small"
								 border
								 class="custom-descriptions">
					<template slot="extra">
						奖罚单编号：{{ form.avNo }}
					</template>
					<el-descriptions-item label="工程项目名称">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="建设单位">{{ form.consUnit }}</el-descriptions-item>
					<el-descriptions-item label="施工单位">{{ form.roadUnit }}</el-descriptions-item>
					<el-descriptions-item label="监理单位">{{ form.supUnit }}</el-descriptions-item>
					<el-descriptions-item label="其他单位">{{ form.otherUnit }}</el-descriptions-item>
					<el-descriptions-item label="奖罚类型">
						{{ form.avType == '1' ? '奖励' : '处罚' }}
					</el-descriptions-item>
					<el-descriptions-item label="奖罚单名称">{{ form.sname }}</el-descriptions-item>
					<el-descriptions-item label="奖罚单签发单位">{{ form.issuUnit }}</el-descriptions-item>
					<el-descriptions-item label="受奖罚单位">{{ form.punishedUnit }}</el-descriptions-item>
					<el-descriptions-item label="奖罚事由"
										  contentClassName="h200">
						{{ form.matter }}
					</el-descriptions-item>
					<el-descriptions-item label="奖罚金额(元)">{{ form.price }}</el-descriptions-item>
					<el-descriptions-item label="奖罚日期">
						{{ form.avDate ? form.avDate.substr(0,10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="奖罚意见"
										  contentClassName="h200">
						{{ form.content }}
					</el-descriptions-item>
					<el-descriptions-item label="上传附件">
						<myUpload listType="list"
								  ref="fileUpload"
								  tableName="audit_award_violation_ticket"
								  uploadType="2"
								  assortment="test666"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.getAwViTicketInfo({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>